export enum QuoteListSortableColumns {
  ExpiryDate = 'expiryDate',
  TimelineTotal = 'timelineTotal',
  FixTotalCost = 'fixTotalCost',
}
